import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["template", "container"]

    add(event) {
        event.preventDefault()
        const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, new Date().getTime())
        this.containerTarget.insertAdjacentHTML("beforeend", content)
        const wrapper = this.containerTarget.lastElementChild
        this.dispatch("added", { detail: { wrapper } })
    }

    remove(event) {
        event.preventDefault()
        const wrapper = event.target.closest(".nested-fields")
        if (wrapper.dataset.newRecord === "true") {
            this.dispatch("removed", { detail: { wrapper } })
            wrapper.remove()
        } else {
            wrapper.querySelector("input[name*='_destroy']").value = 1
            wrapper.style.display = "none"
            this.dispatch("removed", { detail: { wrapper } })
        }
    }

    preview(event) {
        const input = event.target
        const preview = input.closest(".nested-fields").querySelector(".image-preview")

        if (input.files && input.files[0]) {
            const reader = new FileReader()
            reader.onload = e => {
                preview.innerHTML = `<img src="${e.target.result}" class="h-25 w-25 object-cover rounded-lg border" />`
            }
            reader.readAsDataURL(input.files[0])
        } else {
            preview.innerHTML = ""
        }
    }
}
